/** @module csi/tabs/ScrollingTabController */
define([
	"dojo/_base/declare",
	"dojo/aspect",
	"dijit/layout/ScrollingTabController",
	"csi/html",
	"dojo/dom-style"
], function (declare, aspect, ScrollingTabController, html, domStyle) {

	return declare(ScrollingTabController, {
		/**
		 * @override
		 * Hide any items in drop down if tab is hidden
		 */
		postCreate: function () {
			const menuBtn = this._menuBtn;

			this.inherited(arguments);

			this.own(aspect.after(menuBtn, "loadDropDown", () => {
				const { dropDown } = menuBtn;
				const menuItems = dropDown.getChildren();
				const tabs = this.getChildren();

				tabs.forEach((tab, i) => {
					html.setVisible(menuItems[i], html.isVisible(tab));
				})
			}));
		},

		/**
		 * @override
		 * Code below consider the fact that we are hiding some tabs. Hidden tabs must be excluded from calculations
		 * because offsetLeft of hidden tab is always zero and therefore calculation below will always return zero 
		 * which leads to hiding scrolling buttons in resize() (bug C8-18225,C8-17903)
		 * 
		 * Removing hidden tabs from calculation is the only difference from original controller. 
		 */
		_getTabsWidth: function () {
			var children = this.getChildren();

			// Difference start (compared to "dijit/layout/ScrollingTabController" )
			var i = children.length;
			while (i-- > 0) {
				if (!html.isVisible(children[i].domNode)) {
					children.splice(i, 1);
				}
			}
			// Difference end

			if (children.length) {
				var leftTab = children[this.isLeftToRight() ? 0 : children.length - 1].domNode;
				var rightTab = children[this.isLeftToRight() ? children.length - 1 : 0].domNode;
				return rightTab.offsetLeft + rightTab.offsetWidth - leftTab.offsetLeft;
			} else {
				return 0;
			}
		},

		/**
		* @override
		* Using last visible child for scroll bound calculations because if last child is invisible it will return
		* offsetLeft and offsetWidth zero which will disable scroll buttons
		* 
		* The only difference from original controller is we are using last visible child instead of last child for 
		* scroll bound calculations 
		*/
		_getScrollBounds: function () {
			// summary:
			//      Returns the minimum and maximum scroll setting to show the leftmost and rightmost
			//      tabs (respectively)
			var children = this.getChildren(),
				scrollNodeWidth = domStyle.get(this.scrollNode, "width"), // about 500px
				containerWidth = domStyle.get(this.containerNode, "width"), // 50,000px
				maxPossibleScroll = containerWidth - scrollNodeWidth, // scrolling until right edge of containerNode visible
				tabsWidth = this._getTabsWidth();

			if (children.length && tabsWidth > scrollNodeWidth) {
				// Scrolling should happen
				// CENTRIC MODIFICATIONS BEGINS				
				var lastVisibleChild = null;
				var i = children.length - 1;
				while (i >= 0) {
					if (html.isVisible(children[i].domNode)) {
						lastVisibleChild = children[i];
						break;
					}
					--i;
				}
				// using original behaviour if no visible child found
				const lastChildForScrollCalc = lastVisibleChild || children[children.length - 1];
				// CENTRIC MODIFICATIONS ENDS

				return {
					min: this.isLeftToRight() ? 0 : lastChildForScrollCalc.domNode.offsetLeft,
					max: this.isLeftToRight() ?
						(lastChildForScrollCalc.domNode.offsetLeft + lastChildForScrollCalc.domNode.offsetWidth) - scrollNodeWidth :
						maxPossibleScroll
				};
			} else {
				// No scrolling needed, all tabs visible, we stay either scrolled to far left or far right (depending on dir)
				var onlyScrollPosition = this.isLeftToRight() ? 0 : maxPossibleScroll;
				return {
					min: onlyScrollPosition,
					max: onlyScrollPosition
				};
			}
		}
	});
});